module.exports = __webpack_public_path__ + "img/8@2x.7703f7aa.png";